// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message-box {
    width: 100%;
    height: 200px; /* İsteğinize göre yüksekliği ayarlayabilirsiniz */
    display: flex;
    justify-content: center; /* Yatayda ortalama */
    align-items: center;     /* Dikeyde ortalama */
    border: 1px solid #ddd;  /* İsteğe bağlı çerçeve */
    border-radius: 8px;      /* Kenarları yuvarlatmak için */
    padding: 20px;
    background-color: #f9f9f9; /* Arka plan rengini isteğinize göre değiştirebilirsiniz */
    position: relative;
}

.document-loader {
    width: 180px;
    height: 220px;
    padding: 20px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    overflow: hidden;
    position: relative;
    border: 4px solid #003c4f;
    border-radius: 8px;
    animation: border-color 3s linear infinite;
}

.line {
    width: 0;
    height: 8px;
    background-color: #3c4f58;
    border-radius: 4px;
    animation: slide-right 1.5s ease-in-out infinite;
}

.line:nth-child(1) {
    animation-delay: 0s;
}

.line:nth-child(2) {
    animation-delay: 0.3s;
}

.line:nth-child(3) {
    animation-delay: 0.6s;
}

@keyframes slide-right {
    0% {
        width: 0;
        opacity: 0.5;
    }
    50% {
        width: 100%;
        opacity: 1;
    }
    100% {
        width: 0;
        opacity: 0.5;
    }
}

@keyframes border-color {
    0% {
        border-color: #003c4f;
    }
    25% {
        border-color: #ff7f50;
    }
    50% {
        border-color: #ffcc00;
    }
    75% {
        border-color: #00cc99;
    }
    100% {
        border-color: #003c4f;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/DocumentLoader/DocumentLoader.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa,EAAE,kDAAkD;IACjE,aAAa;IACb,uBAAuB,EAAE,qBAAqB;IAC9C,mBAAmB,MAAM,qBAAqB;IAC9C,sBAAsB,GAAG,yBAAyB;IAClD,kBAAkB,OAAO,+BAA+B;IACxD,aAAa;IACb,yBAAyB,EAAE,0DAA0D;IACrF,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,aAAa;IAEb,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,0CAA0C;AAC9C;;AAEA;IACI,QAAQ;IACR,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,gDAAgD;AACpD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI;QACI,QAAQ;QACR,YAAY;IAChB;IACA;QACI,WAAW;QACX,UAAU;IACd;IACA;QACI,QAAQ;QACR,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,qBAAqB;IACzB;IACA;QACI,qBAAqB;IACzB;IACA;QACI,qBAAqB;IACzB;IACA;QACI,qBAAqB;IACzB;IACA;QACI,qBAAqB;IACzB;AACJ","sourcesContent":[".message-box {\r\n    width: 100%;\r\n    height: 200px; /* İsteğinize göre yüksekliği ayarlayabilirsiniz */\r\n    display: flex;\r\n    justify-content: center; /* Yatayda ortalama */\r\n    align-items: center;     /* Dikeyde ortalama */\r\n    border: 1px solid #ddd;  /* İsteğe bağlı çerçeve */\r\n    border-radius: 8px;      /* Kenarları yuvarlatmak için */\r\n    padding: 20px;\r\n    background-color: #f9f9f9; /* Arka plan rengini isteğinize göre değiştirebilirsiniz */\r\n    position: relative;\r\n}\r\n\r\n.document-loader {\r\n    width: 180px;\r\n    height: 220px;\r\n    border-radius: 8px;\r\n    padding: 20px;\r\n    background-color: #fff;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-around;\r\n    overflow: hidden;\r\n    position: relative;\r\n    border: 4px solid #003c4f;\r\n    border-radius: 8px;\r\n    animation: border-color 3s linear infinite;\r\n}\r\n\r\n.line {\r\n    width: 0;\r\n    height: 8px;\r\n    background-color: #3c4f58;\r\n    border-radius: 4px;\r\n    animation: slide-right 1.5s ease-in-out infinite;\r\n}\r\n\r\n.line:nth-child(1) {\r\n    animation-delay: 0s;\r\n}\r\n\r\n.line:nth-child(2) {\r\n    animation-delay: 0.3s;\r\n}\r\n\r\n.line:nth-child(3) {\r\n    animation-delay: 0.6s;\r\n}\r\n\r\n@keyframes slide-right {\r\n    0% {\r\n        width: 0;\r\n        opacity: 0.5;\r\n    }\r\n    50% {\r\n        width: 100%;\r\n        opacity: 1;\r\n    }\r\n    100% {\r\n        width: 0;\r\n        opacity: 0.5;\r\n    }\r\n}\r\n\r\n@keyframes border-color {\r\n    0% {\r\n        border-color: #003c4f;\r\n    }\r\n    25% {\r\n        border-color: #ff7f50;\r\n    }\r\n    50% {\r\n        border-color: #ffcc00;\r\n    }\r\n    75% {\r\n        border-color: #00cc99;\r\n    }\r\n    100% {\r\n        border-color: #003c4f;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
